import {
  category_legend,
  month_weeks,
  tabs,
  timeline_groups
} from './regulatory_calendar_schedule_data';
import {
  category_cards,
  escalation_steps,
  month_label,
  reminder_rules
} from './regulatory_calendar_reference_data';

export default {
  name: 'ComplyonRegulatoryCalendar',
  data: () => ({
    tabs,
    active_tab: 'timeline',
    category_legend,
    month_weeks,
    timeline_groups,
    category_cards,
    reminder_rules,
    escalation_steps,
    month_label
  }),
  methods: {
    set_tab(tab_key) {
      this.active_tab = tab_key;
    }
  }
};
